// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"d21be944","847":"5e2b6863"}[chunkId] + ".chunk.css";
};